import styled from 'styled-components'

const PointlessDiv = styled.div`
  pointer-events: none;
  height: inherit;
`

export default PointlessDiv
